module.exports = __webpack_public_path__ + "15c265ad68f16173da601bda70aa2b31.otf";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/Platform-Regular.otf
// module id = 1098
// module chunks = 0